import React, { Fragment, useState, useEffect } from 'react';

import { getIndentClass } from '../../utils/styleUtils';

import ExpenseProjectRow from './ExpenseProjectRow';
import ExpenseRow from './ExpenseRow';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function ExpenseCostcenterRow(props) {
    const [showCostCenter, setShowCostCenter] = useState(false);

    // Handle expand all trigger from parent with staggered updates
    useEffect(() => {
        const t = props.expandAllTrigger;
        if (!t?.version) return;

        if (t.batch === 'costcenters') {
            setShowCostCenter(t.expanded);
        }
    }, [props.expandAllTrigger?.version]);

    // Calculate indentation level
    const indentLevel = props.indentLevel;
    const childIndentLevel = indentLevel + 1;

    return (
        <>
            <tr className="!tw-bg-blue-100">
                <td className="tw-font-bold tw-cursor-pointer !tw-border-r-0" onClick={() => setShowCostCenter(!showCostCenter)}>
                    <div className="tw-flex tw-items-center tw-gap-x-1.5">
                        <div className={`!tw-text-blue ${getIndentClass(indentLevel)}`}>{props.costcenter.name}</div>
                        <div>{showCostCenter ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                    </div>
                </td>
                <td className="tw-p-4 !tw-border-x-0"></td>
                <td className="tw-font-bold tw-cursor-pointer tw-border-r-2" onClick={() => setShowCostCenter(!showCostCenter)}></td>
                <td
                    colSpan={props.maxExpenseMilestonesCount * 2 + 3}
                    className="tw-font-bold tw-cursor-pointer !tw-border-l-0"
                    onClick={() => setShowCostCenter(!showCostCenter)}
                ></td>
            </tr>

            {showCostCenter && (
                <Fragment>
                    {props.costcenter.projects &&
                        props.costcenter.projects.length > 0 &&
                        props.costcenter.projects.map((project) => {
                            return (
                                <ExpenseProjectRow
                                    ExpenseMilestoneUpdateUrl={props.ExpenseMilestoneUpdateUrl}
                                    SponsorMilestoneUpdateUrl={props.SponsorMilestoneUpdateUrl}
                                    RevenueMilestoneUpdateUrl={props.RevenueMilestoneUpdateUrl}
                                    minDate={props.minDate}
                                    maxDate={props.maxDate}
                                    key={`tr_expense_pr_${project.id}`}
                                    project={project}
                                    maxExpenseMilestonesCount={props.maxExpenseMilestonesCount}
                                    increaseMaxExpenseMilestonesCount={props.increaseMaxExpenseMilestonesCount}
                                    editingExpenseId={props.editingExpenseId}
                                    editingType={props.editingType}
                                    editingMilestoneId={props.editingMilestoneId}
                                    setExpenseEditing={props.setExpenseEditing}
                                    modalShow={props.modalShow}
                                    canEdit={props.canEdit}
                                    milestoneType={props.milestoneType}
                                    periods={props.periods}
                                    setLoading={props.setLoading}
                                    indentLevel={childIndentLevel}
                                    fetchCentralCashflow={props.fetchCentralCashflow}
                                    expandAllTrigger={props.expandAllTrigger}
                                    editAllTrigger={props.editAllTrigger}
                                />
                            );
                        })}
                    {props.costcenter.expenses &&
                        props.costcenter.expenses.length > 0 &&
                        props.costcenter.expenses.map((expense) => {
                            return (
                                <ExpenseRow
                                    ExpenseMilestoneUpdateUrl={props.ExpenseMilestoneUpdateUrl}
                                    SponsorMilestoneUpdateUrl={props.SponsorMilestoneUpdateUrl}
                                    RevenueMilestoneUpdateUrl={props.RevenueMilestoneUpdateUrl}
                                    minDate={props.minDate}
                                    maxDate={props.maxDate}
                                    key={`tr_expense_${expense.id}`}
                                    expense={expense}
                                    maxExpenseMilestonesCount={props.maxExpenseMilestonesCount}
                                    increaseMaxExpenseMilestonesCount={props.increaseMaxExpenseMilestonesCount}
                                    editingExpenseId={props.editingExpenseId}
                                    editingType={props.editingType}
                                    editingMilestoneId={props.editingMilestoneId}
                                    setExpenseEditing={props.setExpenseEditing}
                                    modalShow={props.modalShow}
                                    canEdit={props.canEdit}
                                    isCostcenterExpense={props.costcentersColor}
                                    milestoneType={props.milestoneType}
                                    periods={props.periods}
                                    setLoading={props.setLoading}
                                    indentLevel={childIndentLevel}
                                    fetchCentralCashflow={props.fetchCentralCashflow}
                                    expandAllTrigger={props.expandAllTrigger}
                                    editAllTrigger={props.editAllTrigger}
                                />
                            );
                        })}
                </Fragment>
            )}
        </>
    );
}
